import classNames from "classnames";
import React from "react";
import { ReactNode, useState } from "react";

export type Tab = {
  label: ReactNode;
  children: ReactNode;
  leftIcon: ReactNode;
  rightIcon: ReactNode;
};

type Props = {
  title?: string;
  items: Tab[];
  onTabChange?(selectedTab: number): void;
  additionalField?: ReactNode;
};

export const Tabs = ({ title, items = [], onTabChange, additionalField }: Props) => {
  const [currentTab, setCurrentTab] = useState(0);

  const contentList = items.reduce<{ [key: string]: ReactNode }>((list, tab, index) => {
    list[index] = tab.children;
    return list;
  }, {});
  return (
    <div className='flex' style={{ columnGap: "30px" }}>
      <div style={{ width: "316px" }}>
        <div
          className='rounded-base bg-white shadow-sm'
          style={{
            width: "304px",
            border: "1px solid #DADFEF",
          }}
        >
          <div className='flex flex-col'>
            {title && (
              <div className='w-full' style={{ padding: "30px", textAlign: "center" }}>
                <span
                  className='font-semibold'
                  style={{
                    fontFamily: "Poppins",
                    lineHeight: "28px",
                    fontSize: "18px",
                  }}
                >
                  {title}
                </span>
              </div>
            )}
            <div className='w-full'>
              <div className='flex flex-col'>
                {items.map((item, index) => (
                  <div
                    key={index}
                    className={classNames("tab flex items-center w-full h-", {
                      selected: currentTab == index,
                    })}
                    style={{
                      height: "75px",
                      padding: "22.5px 16px 22.5px 16px",
                    }}
                    onClick={() => {
                      setCurrentTab(index);
                      onTabChange?.(index);
                    }}
                  >
                    <div
                      className='flex w-full'
                      style={{
                        flexFlow: "row wrap",
                        flexWrap: "nowrap",
                        flex: "0 0 auto",
                      }}
                    >
                      {item.leftIcon && (
                        <div
                          className='flex-auto'
                          style={{
                            minWidth: "0px",
                          }}
                        >
                          <div
                            className='flex w-full items-center'
                            style={{
                              flexFlow: "row wrap",
                              flexWrap: "nowrap",
                            }}
                          >
                            <div
                              className='text-center'
                              style={{
                                width: "42px",
                                height: "26px",
                                marginRight: "15px",
                              }}
                            >
                              {item.leftIcon}
                            </div>
                            <div style={{ width: "173px" }}>
                              <span
                                className='uppercase text-sm font-semibold'
                                style={{
                                  lineHeight: "24px",
                                  maxWidth: "173px",
                                  letterSpacing: "0.28px",
                                }}
                              >
                                {item.label}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className='p-0' style={{ margin: "auto" }}>
                        {item.rightIcon}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {additionalField}
      </div>
      <div style={{ width: "738px" }}>{contentList[currentTab]}</div>
    </div>
  );
};
